import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import Company from "../../../components/forms/Settings/Company";
import Form from "../../../components/forms/utils/Form";
import { useCurrentUser } from "../../../utils/CurrentUserContext";
import SettingsCard from "./SettingsCard";
import { UPDATE_COMPANY } from "../../../utils/api/company";
import { UserRole } from "../../../__generated__/graphql";

const AdvancedAccount = () => {
  const {user} = useCurrentUser()
  const [updateCompany] = useMutation(UPDATE_COMPANY)

  const handleSubmit = (_, dirtyValues) => {
    updateCompany({variables: {id: user.companyId, record: dirtyValues}})
  };

  return (
    <SettingsCard title="Company details">
      <Form
        submitButtonText="Save"
        defaultValues={{ name: user.company.name }}
        onSubmit={handleSubmit}
        readOnly={user.role === UserRole.RegularUser}
      >
        <Company />
      </Form>
    </SettingsCard>
  );
};

export default AdvancedAccount;
